import { cn, NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { limitSummerTires, limitWinterTires, recommendedSummerTires, recommendedWinterTires } from 'noddi-util';
import { summerTireTranslations, TireWearInfoTranslations, winterTireTranslations } from './tireWearTranslations';

type Props = {
  season: 'summer' | 'winter';
  translations?: Partial<TireWearInfoTranslations>;
};

export const TireWearInfoContent = ({ season, translations }: Props) => {
  const defaultTranslations = season === 'winter' ? winterTireTranslations : summerTireTranslations;
  const t = { ...defaultTranslations, ...translations };

  const isWinter = season === 'winter';
  const limit = isWinter ? limitWinterTires : limitSummerTires;
  const recommended = isWinter ? recommendedWinterTires : recommendedSummerTires;

  return (
    <div className='flex flex-col gap-3'>
      <p className='text-sm font-semibold'>{t.title}</p>

      <div className='flex flex-col gap-2'>
        <TireWearRow variant='success' label={t.goodCondition} value={`> ${recommended} mm`} />
        <TireWearRow variant='warning' label={t.shouldBeReplaced} value={`${limit} - ${recommended} mm`} />
        <TireWearRow variant='destructive' label={t.mustBeReplaced} value={`< ${limit} mm`} />
      </div>

      <div className='flex flex-col gap-1 border-t pt-3'>
        <p className='text-xs font-medium'>{t.regulationsTitle}</p>
        <p className='text-xs text-muted-foreground'>{t.regulationsDescription}</p>
      </div>
    </div>
  );
};

type TireWearRowProps = {
  variant: 'success' | 'warning' | 'destructive';
  label: string;
  value: string;
};

const TireWearRow = ({ variant, label, value }: TireWearRowProps) => {
  const iconName = variant === 'success' ? 'Check' : variant === 'warning' ? 'Info' : 'X';

  return (
    <div className='flex items-center justify-between gap-3'>
      <NoddiBadge variant={variant} className={cn('gap-1')}>
        <NoddiIcon name={iconName} size='xSmall' />
        {label}
      </NoddiBadge>
      <span className='text-end text-xs text-muted-foreground'>{value}</span>
    </div>
  );
};
